import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { selectAction, userPermissionAction } from "../../redux/rootReducer";
import Checkbox from "../Checkbox/Checkbox";
import Select from "../Select/Select";
import { SELECT_INITIAL, USER_PERMISSION_FORM_INITIAL } from "../../redux/initialStateConstant";
import { setUserPermissionSagaAction } from "../../redux/sagaActions";

const UserPermissionForm = () => {
    const dispatch = useDispatch();

    const subscription_coaches = useSelector(state => state.subscription_coaches);
    const user_permission = useSelector(state => state.user_permission);

    if (!user_permission.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => dispatch(userPermissionAction(USER_PERMISSION_FORM_INITIAL)) }/>
                        <div className="form__title">Права доступа</div>
                    </div>
                    <div className={ `form__field ${ user_permission?.coach?.id ? 'form__field--disable' : '' }` }>
                        <Checkbox
                            active={ user_permission.role === 'admin' }
                            caption={ 'Администратор' }
                            handler={ () => dispatch(userPermissionAction({
                                ...user_permission,
                                role: user_permission.role === 'admin' ? 'user' : 'admin'
                            })) }
                        />
                    </div>
                    <div className={ `form__field ${ user_permission?.role === 'admin' ? 'form__field--disable' : '' }` }>
                        <div className="input__caption">Права тренера</div>
                        <Select
                            current={ user_permission.coach.name }
                            type={ 'user-coach' }
                            options={ subscription_coaches.map((el, index) => {
                                if (index === 0) {
                                    return { id: '', name: 'Обычный посетитель' };
                                }
                                else {
                                    return el;
                                }
                            }) }
                            handler={ elem => {
                                dispatch(userPermissionAction({
                                    ...user_permission,
                                    coach: elem
                                }));
                                dispatch(selectAction(SELECT_INITIAL));
                            } }
                            smart={ true }
                        />
                    </div>
                    <div className="form__field">
                        <div className="button" onClick={ () => dispatch(setUserPermissionSagaAction({
                            id: user_permission.u_id,
                            role: user_permission.role,
                            coach: user_permission.coach.id
                        })) }>Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserPermissionForm;